// extracted by mini-css-extract-plugin
export default {"inputs":"CreateBatch_inputs__1YzUr","textInput":"CreateBatch_textInput__Ev9gd","description":"CreateBatch_description__9LONW"};